<template>
  <div>
    <OnboardingIndex
      title="Check your email"
      :hide_submit_button="true"
    >
      <template v-slot:form-content>
        <div class="text-center mb-4">
          <i class="bi bi-envelope-check fs-1 text-primary mb-3"></i>
          <h6 class="text-secondary mb-3 text-xs">
            We've sent a password reset link to your email address. Please check your inbox and follow the instructions to reset your password.
          </h6>
          <p class="text-muted text-xs">
            If you don't see the email, please check your spam folder.
          </p>
          
          <div class="mt-4">
            <button 
              class="btn px-4 text-xs btn-sm"
              :class="{
                'btn-primary': !is_resend_disabled && countdown === 0, 
                'btn-secondary': is_resend_disabled || countdown > 0
              }"
              @click="resend_email"
              :disabled="is_resend_disabled || countdown > 0"
            >
              <template v-if="!is_resend_disabled && countdown === 0">
                <i class="bi bi-envelope me-2"></i>Resend email
              </template>
              <template v-else>
                <i class="bi bi-clock me-2"></i>Resend available in {{ countdown }}s
              </template>
            </button>
          </div>
        </div>
      </template>

      <template v-slot:signup-content>
        <div class="mt-4 text-center">
          <p class="mb-0 text-xs">
            Back to
            <router-link to="/" class="text-primary text-decoration-none text-xs">Login</router-link>
          </p>
        </div>
      </template>
    </OnboardingIndex>
  </div>
</template>